import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './Home';
import RegisterInterest from './RegisterInterest';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<RegisterInterest />} />
    </Routes>
  );
}

export default App;
